
import TagTree from './tag-tree.vue';

export default {
  components: {
    TagTree: TagTree
  },

  data: function data() {
    return {
      query: {
        tag_type: ''
      },

      tags: [{
        label: '素材特征（非交互）',
        type: 'noninteractive-tag',
        permissionKey: 'system.noninteractive-tag.list'
      }, {
        label: '素材特征（交互）',
        type: 'interactive-tag',
        permissionKey: 'system.interactive-tag.list'
      }, {
        label: '元素标签（交互）',
        type: 'interactive-resource-tag',
        permissionKey: 'res_store.tag.list1'
      }, {
        label: '元素标签（非交互）',
        type: 'noninteractive-resource-tag',
        permissionKey: 'res_store.tag.list2'
      }, {
        label: '视频模版库',
        type: 'system-video-tag',
        permissionKey: 'system.video-tag.list'
      }]
    };
  },


  watch: {
    $route: function $route(to, from) {
      this.query.tag_type = to.query.tag_type;
    }
  },

  mounted: function mounted() {
    this.query.tag_type = this.$route.query.tag_type;
  },


  methods: {
    handleTabClick: function handleTabClick(tab, event) {
      this.$router.push({
        name: 'butler.creative-tag-manage',
        query: {
          tag_type: tab.name
        }
      });
    }
  }
};